<template>
  <div>
    <div class="workOrder_info">
      <div class="left">
        <p>报修位置: {{ this.info.deskName }}{{ this.info.facilitySite ? '-' + this.info.facilitySite : null }}</p>
        <p v-show="this.info.isFastOrder == 1 ? false : true">
          设备编号:
          <span
              style="color: #409eff; cursor: pointer"
              @click="toInfo2(assetId)"
          >{{ this.assetNum }}</span
          >
        </p>
        <p>
          设备名称:
          {{ this.info.facilityName == null ? "无" : this.info.facilityName }}
        </p>
        <p>工单类型: {{ this.info.typeName }}</p>
        <p>工单编号: {{ this.info.workNo }}</p>
        <p>产生费用: {{ this.info.expensesIncurred?this.info.expensesIncurred:0 }}</p>
      </div>

      <div class="center" v-show="this.info.state == 3 ? true : false">
        <el-steps :active="5" align-center>
          <el-step title="建单"
                   :description="this.info.createTime"
                   icon="el-icon-add-location"
          ></el-step>
          <el-step
              title="响应时间"
              :description="responseTime"
              icon="el-icon-time"
              style="color: red"
          ></el-step>
          <el-step
              title="处理"
              :description="this.info.receiveTime"
              icon="el-icon-refresh-right"
          ></el-step>
          <el-step
              title="处理时间"
              :description="handlingTime"
              icon="el-icon-time"
          ></el-step>
          <el-step title="完成"
                   :description="this.info.finishTime"
                   icon="el-icon-circle-check"
          ></el-step>
        </el-steps>
        <!--  <p class="elp elp1">{{ responseTime }}</p>
        <p class="elp elp2">{{ handlingTime }}</p> -->
      </div>
      <div class="right" style="margin-right: 10px">
        <h1 class="common_color1" v-if="this.info.state === 1">待处理</h1>
        <h1 class="common_color2" v-if="this.info.state === 2">处理中</h1>
        <h1 class="common_color3" v-if="this.info.state === 3">
          {{ handlingTime2 }}
        </h1>
      </div>
    </div>
    <el-divider class="divider"></el-divider>
    <div class="block">
      <el-timeline>
        <!-- 待处理 -->
        <div v-if="this.info.state === 1">
          <el-timeline-item
              :timestamp="this.info.createTime"
              placement="top"
              size="large"
              color="#409eff"
          >
            <el-card>
              <h3>创建工单</h3>
              <span >报修时间: {{ this.info.createTime }}</span>
              <p style="height: 10px"></p>
              <p>信息来源: {{ text }}</p>
              <p>工单类型: {{ oldType }}</p>
              <p>
                派单方式:
                {{ this.info.sendType == 1 ? "手动派单" : "自动派单" }}
              </p>
              <p v-show="this.info.maintainerName == null ? false : true">
                指派接单: {{ this.info.maintainerName }}
              </p>
              <div v-show="this.info.descr == null ? false : true">
                <p>报修内容: {{ this.info.descr }}</p>
                <div>
                  <audio
                      style="height: 25px; width: 280px"
                      controls="controls"
                      :src="this.info.voiceUrl"
                      ref="audio"
                      v-show="this.info.voiceUrl ? true : false"
                  ></audio>
                  &nbsp;
                  <el-image
                      style="width: 50px; height: 50px"
                      :src="url"
                      :preview-src-list="imgurls"
                      :initial-index="0"
                      fit="cover"
                      slot="error"
                      v-show="this.info.imgUrl ? true : false"
                  >
                  </el-image>
                </div>
              </div>
              <div v-show="oldname ? true : false">
                <p>
                  {{ createTime }} <i class="el-icon-d-arrow-right"></i>
                  {{ oldname }}将工单转给{{ newname }}
                </p>
                <p v-show="block">
                  {{ updateTime }} <i class="el-icon-d-arrow-right"></i>
                  {{ newname }}{{ remark }}{{ oldname }}转派的工单
                </p>
              </div>
            </el-card>
          </el-timeline-item>
        </div>

        <!-- 处理中 -->
        <div v-if="this.info.state === 2">
          <el-timeline-item
              :timestamp="this.info.receiveTime"
              placement="top"
              color="#409eff"
          >
            <el-card>
              <h3>工单处理中</h3>
              <span >接单时间: {{ this.info.receiveTime }}</span>
              <p style="height: 10px"></p>
              <p>{{ maintainerName }}已接单</p>
              <div v-for="item in data2" :key="item">
                <p>
                  {{ item.createTime }} <i class="el-icon-d-arrow-right"></i>
                  {{ maintainerName }}邀请{{
                    item.maintainerName
                  }}作为协同维修员
                </p>
                <p>
                  {{ item.updateTime }} <i class="el-icon-d-arrow-right"></i>
                  {{
                    item.maintainerName
                  }}{{
                    item.synergyState == 1
                        ? "待确认"
                        : item.synergyState == 2
                            ? "已拒绝"
                            : item.synergyState == 3 || item.synergyState == 4
                                ? "已接受"
                                : ""
                  }}{{ maintainerName }}的协同工单
                </p>
              </div>
              <div v-for="item in sysWorkTracks" :key="item">
                <p v-show="item.workState == 2 ? true : false">
                  {{ item.createTime }} <i class="el-icon-d-arrow-right"></i>
                  {{ item.maintainerName }}填写维修记录:{{
                    item.maintainerContent
                  }}
                </p>
                <p v-show="item.changeTypeId == null || item.changeTypeId == 0 || item.workState == 3 ? false : true">
                  {{ item.maintainerName }}变更工单类型为:{{
                    item.changeTypeId
                  }}
                </p>
                <span v-show="item.state == 3 ? true : false"
                >{{ item.maintainerName }}修改状态为已完成</span
                >
              </div>
            </el-card>
          </el-timeline-item>
          <el-timeline-item
              :timestamp="this.info.createTime"
              placement="top"
              size="large"
          >
            <el-card>
              <h3>创建工单</h3>
              <span >报修时间: {{ this.info.createTime }}</span>
              <p style="height: 10px"></p>
              <p>信息来源: {{ text }}</p>
              <p>工单类型: {{ oldType }}</p>
              <p>
                派单方式:
                {{ this.info.sendType == 1 ? "手动派单" : "自动派单" }}
              </p>
              <p v-show="this.info.maintainerName == null ? false : true">
                指派接单: {{ this.info.maintainerName }}
              </p>
              <div v-show="this.info.descr == null ? false : true">
                <p>报修内容: {{ this.info.descr }}</p>
                <div>
                  <audio
                      style="height: 25px; width: 280px"
                      controls="controls"
                      :src="this.info.voiceUrl"
                      ref="audio"
                      v-show="this.info.voiceUrl ? true : false"
                  ></audio>
                  &nbsp;
                  <el-image
                      style="width: 50px; height: 50px"
                      :src="url"
                      :preview-src-list="imgurls"
                      :initial-index="0"
                      fit="cover"
                      slot="error"
                      v-show="this.info.imgUrl ? true : false"
                  >
                  </el-image>
                </div>
              </div>
              <div v-show="oldname ? true : false">
                <p>
                  {{ createTime }} <i class="el-icon-d-arrow-right"></i>
                  {{ oldname }}将工单转给{{ newname }}
                </p>
                <p v-show="block">
                  {{ updateTime }} <i class="el-icon-d-arrow-right"></i>
                  {{ newname }}{{ remark }}{{ oldname }}转派的工单
                </p>
              </div>
            </el-card>
          </el-timeline-item>
        </div>

        <!-- 已完成 -->
        <div v-if="this.info.state === 3">
          <el-timeline-item
              :timestamp="this.info.finishTime"
              placement="top"
              color="#409eff"
          >
            <el-card>
              <h3>工单已完成</h3>
              <span >完成时间: {{ this.info.finishTime }}</span>
              <p style="height: 10px"></p>
              <div v-for="item in sysWorkTracks" :key="item">
                <p
                    v-show="
                    item.changeTypeId == null || item.changeTypeId == 0 || item.workState == 2
                      ? false
                      : true
                  "
                >
                  {{ item.maintainerName }}变更工单类型为:{{
                    item.changeTypeId
                  }}
                </p>
                <p v-show="item.workState == 3 ? true : false">
                  {{ item.createTime }} <i class="el-icon-d-arrow-right"></i>
                  {{ item.maintainerName }}填写维修记录:{{
                    item.maintainerContent
                  }}
                </p>
              </div>
              <p style="fontsize: 20px">
                {{ this.info.maintainerName }}已完成工单
              </p>
            </el-card>
          </el-timeline-item>
          <el-timeline-item :timestamp="this.info.receiveTime" placement="top">
            <el-card>
              <h3>工单处理中</h3>
              <span >接单时间: {{ this.info.receiveTime }}</span>
              <p style="height: 10px"></p>
              <p>{{ maintainerName }}已接单</p>
              <div v-for="item in data2" :key="item">
                <p>
                  {{ item.createTime }} <i class="el-icon-d-arrow-right"></i>
                  {{ maintainerName }}邀请{{
                    item.maintainerName
                  }}作为协同维修员
                </p>
                <p>
                  {{ item.updateTime }} <i class="el-icon-d-arrow-right"></i>
                  {{
                    item.maintainerName
                  }}{{
                    item.synergyState == 1
                        ? "待确认"
                        : item.synergyState == 2
                            ? "已拒绝"
                            : item.synergyState == 3 || item.synergyState == 4
                                ? "已接受"
                                : ""
                  }}{{ maintainerName }}的协同工单
                </p>
              </div>
              <div v-for="item in sysWorkTracks" :key="item">
                <p v-show="item.workState == 2 ? true : false">
                  {{ item.createTime }} <i class="el-icon-d-arrow-right"></i>
                  {{ item.maintainerName }}填写维修记录:{{
                    item.maintainerContent
                  }}
                </p>
                <p v-show="item.changeTypeId == null || item.changeTypeId == 0 || item.workState == 3 ? false : true">
                  {{ item.maintainerName }}变更工单类型为:{{
                    item.changeTypeId
                  }}
                </p>
                <span v-show="item.workState == 2 ? true : false"
                >{{ item.maintainerName }}修改状态为维修中</span
                >
              </div>
            </el-card>
          </el-timeline-item>
          <el-timeline-item
              :timestamp="this.info.createTime"
              placement="top"
              size="large"
          >
            <el-card>
              <h3>创建工单</h3>
              <span >报修时间: {{ this.info.createTime }}</span>
              <p style="height: 10px"></p>
              <p>信息来源: {{ text }}</p>
              <p>工单类型: {{ oldType }}</p>
              <p>
                派单方式:
                {{ this.info.sendType == 1 ? "手动派单" : "自动派单" }}
              </p>
              <p v-show="this.info.maintainerName == null ? false : true">
                指派接单: {{ this.info.maintainerName }}
              </p>
              <div v-show="this.info.descr == null ? false : true">
                <p>报修内容: {{ this.info.descr }}</p>
                <div>
                  <audio
                      style="height: 25px; width: 280px"
                      controls="controls"
                      :src="this.info.voiceUrl"
                      ref="audio"
                      v-show="this.info.voiceUrl ? true : false"
                  ></audio>
                  &nbsp;
                  <el-image
                      style="width: 50px; height: 50px"
                      :src="url"
                      :preview-src-list="imgurls"
                      :initial-index="0"
                      fit="cover"
                      slot="error"
                      v-show="this.info.imgUrl ? true : false"
                  >
                    <div slot="error" class="image-slot">
                      <img src="../../../assets/img/pictureSplit.png" alt="" />
                    </div>
                  </el-image>
                </div>
              </div>
              <div v-show="oldname ? true : false">
                <p>
                  {{ createTime }} <i class="el-icon-d-arrow-right"></i>
                  {{ oldname }}将工单转给{{ newname }}
                </p>
                <p v-show="block">
                  {{ updateTime }} <i class="el-icon-d-arrow-right"></i>
                  {{ newname }}{{ remark }}{{ oldname }}转派的工单
                </p>
              </div>
            </el-card>
          </el-timeline-item>
        </div>
      </el-timeline>
    </div>
  </div>
</template>
<script>
import Clipboard from "clipboard";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import {IMAGE_HOST} from "../../../../config";

export default {
  name: "orderInfo",
  components: {ElImageViewer},
  props: {
    kv: null,
    workId: {
      type: String,
      value: "",
    },
    callId: {
      type: String,
      value: "",
    },
  },
  watch: {
    kv(v) {
    },
  },
  data() {
    return {
      text: "",
      mname: "work",
      url: "",
      items: [], // 显示条目
      info: {},
      imgUrl: "",
      imgVisible: false,
      imgVisibles: false,
      list: [],
      id: "",
      synergyState: "", //?是否协同工单
      // synergyList:[],  //?协同工单人员
      //转单列表
      columns1: [
        {
          title: "转单号",
          minWidth: 100,
          key: "id",
          align: "center",
        },
        {
          title: "工单号",
          minWidth: 100,
          key: "workNo",
          align: "center",
        },
        {
          title: "原维修员",
          minWidth: 110,
          key: "originalName",
          align: "center",
        },
        {
          title: "现维修员",
          minWidth: 100,
          key: "name",
          align: "center",
        },
        {
          title: "转单状态",
          key: "state",
          minWidth: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text =
                row.state == 1
                    ? "转单中"
                    : row.state == 2
                        ? "已退回"
                        : row.state == 3
                            ? "转单成功"
                            : "";
            return <span style={{"font-size": "14px"}}>{text}</span>;
          },
        },
        {
          title: "备注",
          minWidth: 120,
          align: "center",
          key: "remark",
        },
        {
          title: "更新时间",
          width: 115,
          align: "center",
          key: "createTime",
          render: (h, params) => {
            const row = params.row;
            const text = row.createTime.slice(0, 16);
            return <span>{text}</span>;
          },
        },
      ],
      //协同列表
      columns2: [
        {
          title: "身份",
          key: "state",
          minWidth: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.workId == this.id ? "主维修员" : "协同人";
            return <span style={{"font-size": "14px"}}>{text}</span>;
          },
        },
        {
          title: "维修员",
          minWidth: 100,
          key: "maintainerName",
          align: "center",
        },
        {
          title: "维修内容",
          minWidth: 110,
          key: "maintainerContent",
          align: "center",
        },
        {
          title: "故障原因",
          minWidth: 100,
          key: "remark",
          align: "center",
        },
        {
          title: "维修图片",
          minWidth: 120,
          align: "center",
          key: "imgUrl",
          viewimage: true,
        },
        {
          title: "更新时间",
          width: 115,
          align: "center",
          key: "createTime",
          render: (h, params) => {
            const row = params.row;
            const text = row.createTime.slice(0, 16);
            return <span>{text}</span>;
          },
        },
      ],
      data1: [],
      data2: [],
      total: this.total,
      imgUrls: [],
      showViewer: false,
      guidePic: null, // 预览图片的地址
      oldname: "", //原维修员名字
      newname: "", //新维修员名字
      remark: "", //转单结果
      createTime: "", //转单时间
      updateTime: "", //接受转单时间
      block: false,
      sysWorkTracks: [], //维修记录
      maintainerName: "",
      oldType: "", //原始工单类型
      responseTime: "", //响应时间
      handlingTime: "", //处理时间
      handlingTime2: "", //总处理时间
      facilityNo: "", //
      assetNum: "", //设备编号
      assetId: "", //设备ID
    };
  },
  created() {
    let route = this.$route;
    this.title = route.title || "";
    let query = this.$route.query;
    if (query.kv) {
      this.kv = query.kv;
    }
    if (this.kv) {
      this.initData(this.kv);
    }
    if (this.workId) {
      this.initData(this.workId);
    }
    if (query.callId) {
      this.callId = query.callId;
    }
    if (this.callId) {
      this.initData(this.callId);
    }
  },
  mounted() {
  },
  methods: {
    showViewerClose() {
      this.showViewer = false;
    },
    getPreview() {
      this.guidePic
          ? (this.showViewer = true)
          : this.$message.info("当前没有可预览的图片");
    },
    playMusic(type) {
      this.$refs.audio.currentTime = 0; //从头开始播放
      this.$refs.audio.play(); //播放
      setTimeout(() => {
        this.$refs.audio.pause(); //停止
      }, 3000);
    },
    initItems() {
      return this.items;
    },
    // loadimg(url, type = "image") {
    //   return $utils.image.load(url, type);
    // },
    initData(workId, page = 1) {
      // 加载详情工单数据
      let id = workId;
      $utils.api.load(`/maintainer/maintainer/workOrder/${id}`, {}).then((res) => {
        if (res && res.data) {
          if (res.data.isFastOrder != 1) {
            this.toInfo(res.data.facilityNo);
          }
          if (res.data.imgUrl) {
            var list = [];
            var imager = ""
            //判断图片路径中是否含有“null”字符串
            if (res.data.imgUrl.indexOf("null") != -1) {
              //如果有的话就去除
              imager = res.data.imgUrl.replace("null","")
            }else{
              //如果没有就正常赋值
              imager = res.data.imgUrl
            }
            //判断图片是否含有多个
            if (imager.indexOf(",") != -1) {
              //如果有多个则按，分割转换成数组
              var splitList = imager.split(",");
              for (var i = 0; i < splitList.length; i++) {
                list.push(IMAGE_HOST + splitList[i]);
              }
            } else {
              list.push(IMAGE_HOST + imager);
            }
            this.imgurls = list;
            this.url = this.imgurls[0];
          }
          this.info = res.data;
          this.maintainerName = res.data.maintainerName
          let repairSource = this.info.repairSource;
          let isFastOrder = this.info.isFastOrder;
          this.responseTime = this.computingTime(
              this.info.createTime,
              this.info.receiveTime
          );
          this.handlingTime = this.computingTime(
              this.info.receiveTime,
              this.info.finishTime
          );
          this.handlingTime2 = this.computingTime(
              this.info.createTime,
              this.info.finishTime
          );
          this.text =
              repairSource === 1 && isFastOrder === 0
                  ? "扫码报修"
                  : repairSource === 1 && isFastOrder === 1
                      ? "移动报修"
                          : repairSource === 3 && isFastOrder === 0
                              ? "后台设备报修"
                              : repairSource === 3 && isFastOrder === 1
                                  ? "后台科室报修"
                                  : repairSource === 2
                                      ? "维修员"
                                      : "";
          let maintainerId = this.info.maintainerId;

          let arr2 = this.info.sysWorkTracks; //维修记录
          this.sysWorkTracks = arr2;
          if (arr2.length == 0) {
            this.oldType = this.info.typeName;
          } else {
            for (let i = 0; i < arr2.length; i++) {
              if (arr2[i].originalTypeId != null) {
                this.loadTypeData(arr2[i].originalTypeId); //初始
                break;
              } else if (arr2[i].originalTypeId == null) {
                this.oldType = this.info.typeName;
              }
            }
          }
          for (let i = 0; i < arr2.length; i++) {
            if (arr2[i].originTypeId == "" || arr2[i].originTypeId == null) {
              this.loadTypeData(this.info.typeId);
            }
            if (arr2[i].changeTypeId != null && arr2[i].changeTypeId != 0) {
              this.loadChangeType(arr2[i].changeTypeId); //更改
            }
          }

          let arr = this.info.sysWorks; //协同工单
          if (arr.length > 0) {
            for (let i = 0; i < arr.length; i++) {
              let li = arr[i];
              if (li.maintainerId !== maintainerId) {
                this.data2.push(li);
              }
            }
          }
        /*   if (this.info.qrCode) {
            this.info.qrCode = this.loadimg(this.info.qrCode);
          } */
          this.id = this.info.id;
        }
      });
      //转单记录
      let q = {};
      q.workId = workId;
      // q.page = page
      q.pageSize = 10;
      q.pageNum = page;
      $utils.api
          .load("/maintainer/maintainer/transfer/list", q)
          .then((res) => {
            if (res.code > 0) {
              let data = res.rows;
              let list = data || [];
              for (let i = 0; i < list.length; i++) {
                this.oldname = list[i].originalName;
                this.newname = list[i].name;
                this.createTime = list[i].createTime;
                this.updateTime = list[i].updateTime;
                if (list[i].remark == "拒绝转单") {
                  this.block = true;
                  this.remark = "已拒绝";
                } else if (list[i].remark == "接受转单") {
                  this.block = true;
                  this.remark = "已接受";
                } else {
                  this.block = false;
                }
              }
              this.data1 = list;
              this.total = res.total;
            }
          })
          .catch(() => {
            $utils.toast.error("请求错误");
          });
    },
    async loadTypeData(typeId) {
      // 通过pk查询字典数据
      let res = await $utils.api.load(`/maintainer/maintainer/workType/${typeId}`);
      if (res && res.code == 200) {
        this.oldType = res.data.name;
        for (let i = 0; i < this.sysWorkTracks.length; i++) {
          let item = this.sysWorkTracks[i];
          if (item.originalTypeId == typeId) {
            item.originalTypeId = res.data.name;
          }
        }
      }
    },
    async loadChangeType(typeId) {
      // 通过pk查询字典数据
      let res = await $utils.api.load(`/maintainer/maintainer/workType/${typeId}`);
      if (res && res.code == 200) {
        for (let i = 0; i < this.sysWorkTracks.length; i++) {
          let item = this.sysWorkTracks[i];
          if (item.changeTypeId == typeId) {
            item.changeTypeId = res.data.name;
          }
        }
      }
    },
    changePage(p) {
      this.load(this.workId, p);
    },
    changePagesize(psize) {
    },
    showImg(src) {
      this.imgUrl = this.info.qrCode;
      this.imgVisible = true;
    },
    showImgs(src) {
      // this.imgUrl = this.imgUrls;
      this.imgVisibles = true;
    },
    //复制工单编号
    copyText() {
      let val = (this.info && this.info.workNo) || "";
      if (this.info && this.info.workNo) {
        let clipboard = new Clipboard("." + val);
        this.$Message.info("已复制工单号：" + val);
      }
    },
    //计算相差时间
    computingTime(a, b) {
      //a开始时间//b结束时间
      var date3 = new Date(b).getTime() - new Date(a).getTime(); //时间差的毫秒数
      //------------------------------
      //计算出相差天数
      // var days = Math.floor(date3 / (24 * 3600 * 1000));
      //计算出小时数
      var leave1 = date3 % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
      var hours = Math.floor(leave1 / (3600 * 1000));
      //计算相差分钟数
      var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
      var minutes = Math.floor(leave2 / (60 * 1000));
      //计算相差秒数
      var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
      var seconds = Math.round(leave3 / 1000);
      return hours + "时" + minutes + "分" + seconds + "秒";
    },
    //查找设备ID
    async toInfo(data) {
      let q = {
        facilityNum: data,
      };
      let res = await $utils.api.load(`/maintainer/maintainer/facility/getFacilityByNum`, q);
      if (res.code == 200) {
        console.log(res.data);
        this.facilityNo = res.data.facility.facilityNum;
        this.assetNum = res.data.facility.assetNum;
        this.assetId = res.data.facility.id;
      }
    },
    //维修记录
    toInfo2(val) {
      $utils.url.push({
        name: "deviceRecordretrieval_list_weixiu",
        query: { facilityId: val ,facilityNo:this.facilityNo },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.workOrder_info {
  width: 100%;
  background: #fff;
  border-radius: 5px;
  display: flex;
  justify-content: space-between;

  .left {
    width: 17%;
  }
  .center {
    width: 65%;
    .elp {
      padding-top: 10px;
      position: fixed;
      top: 110px;
      color: #409eff;
    }
    .elp1 {
      left: 44.875rem;
    }
    .elp2 {
      left: 30.375rem;
    }
  }

  .right {
    color: #000;
    font-size: 13px;
    font-weight: 500;
  }
}

.workOrder_info2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: #fff;
  border-radius: 5px;
  position: relative;
  margin-bottom: 10px;
  padding-left: 18px;
  padding-right: 140px;
  /* .left {
    margin-left: 18px;
  }
  .right {
    position: absolute;
    right: 138px;
  } */
}

.workOrder_content {
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
  background: #fff;
  width: 100%;
  border-radius: 5px;

  .title {
    color: #000;
    font-size: 13px;
    font-weight: 600;
  }

  .item_box {
    display: flex;
  }
}

.workOrder_br {
  height: 1px;
  width: 100%;
  background: #f7f7f7;
}

.common_title {
  color: #000;
  font-size: 13px;
  font-weight: 500;
}

.common_image {
  width: 60px;
  height: 60px;
  border-radius: 2px;
  background: #f7f7f7;
}

.common_image_weixiu {
  width: 60px;
  height: 160px;
  border-radius: 2px;
  background: #fff;
  display: flex;
}

.common_color {
  color: #666;
}

.common_color1 {
  color: orange;
  padding-top: 10px;
}

.common_color2 {
  color: blue;
  padding-top: 10px;
}

.common_color3 {
  color: green;
  padding-top: 10px;
}

.block {
  margin-top: 30px;
  p,
  span {
    font-size: 16px;
  }
}

.divider {
  margin: 0;
}
</style>
